import { Progress } from "antd";
import React from "react";
import Button from "../../../shared/Button";
import SemiCircleProgress from "./SemiCircleProgressbar";

const MyCounterHeader = () => {
  return (
    <div className="container">
      <div className="MyCounterHeader">
       
        <div className="smily-div MyCounterHeader--div ">
          <h3>برسی آخرین تخفیفات ویژه</h3>
          <p>به اقامتگاه های دوست داشتتی سفر کنید</p>
          <Button className="primary-counter" varient="primary">مشاهده بیشتر</Button>
        </div>

        <div className="black-div MyCounterHeader--div center-column ">
          <SemiCircleProgress />
          <h4>از پروفایل شما تکمیل شده است</h4>
          <p>
          اطلاعات شخصی پروفایل خود را تکمیل کنید تا نشان تایید دریافت کنید
          </p>
          <Button varient="primary">تکمیل پروفایل کاربری</Button>
        </div>
        <div className="majic-div MyCounterHeader--div ">
          <h3>جزوی از مجله جاتیک باشید !!!</h3>
          <p>با نویسندگی در مجله جاتیک به گردشگران کمک کنید</p>
          <Button  className="primary-counter" varient="primary">مشاهده بیشتر</Button>
        </div>
     
      </div>
    </div>
  );
};

export default MyCounterHeader;
